import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/beta-status")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
